<template>
  <div class="landing-wrapper">
    <v-container class="py-8 py-md-12" fluid>
      <v-row justify="center">
        <v-col cols="12" lg="10">
          <div class="section-panel">
            <div class="section-panel-header">
              <v-icon size="22" color="#ffffff">{{ icon }}</v-icon>
              <span>{{ title }}</span>
            </div>
            <div class="section-panel-body">
              <v-icon size="56" color="#c8102e">mdi-progress-wrench</v-icon>
              <p class="section-soon">Esta sección estará disponible próximamente.</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <teatro-footer />
  </div>
</template>

<script>
export default {
  name: "SectionPlaceholder",
  props: {
    title: {
      type: String,
      default: "Sección",
    },
    icon: {
      type: String,
      default: "mdi-information-outline",
    },
  },
  async created() {
    try {
      await this.$store.dispatch("fetchIsAuthenticated");
    } catch (e) {
      console.error(e);
    }
  },
};
</script>

<style scoped>
.section-panel {
  max-width: 1080px;
  margin: 0 auto;
  background: rgba(8, 5, 5, 0.66);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 26px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
}

.section-panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 66px;
  padding: 0 32px;
  background: linear-gradient(90deg, #c8102e 0%, #a50d25 100%);
  color: #fff;
  font-family: var(--font-family-heading);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.4px;
}

.section-panel-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 70px 34px;
  text-align: center;
}

.section-soon {
  margin: 0;
  color: var(--color-theater-text-muted);
  font-family: var(--font-family-heading);
  font-size: 14px;
  letter-spacing: 0.5px;
}
</style>
